import SessionStore from 'dashboard-js/providers/SessionStore'

export default {
    data() {
        return {
            _stateKey: null,
        }
    },

    mounted() {
        this.createKey()
        this.restore()
    },

    beforeDestroy() {
        this.backup()
    },

    methods: {
        backup() {
            const payload = this.getTargetPayload()

            if (Object.keys(payload).length > 0) {
                SessionStore.set(this._stateKey, payload)
            }
        },

        createKey() {
            const componentKey = this.$get(
                this.$vnode,
                'key',
                [this.getComponentKey(this.$parent), this.getComponentKey(this.target)].join('__')
            )

            this._stateKey = 'PreservesState__' + componentKey
        },

        getTargetProperties() {
            return Object.keys(this.$get(this.target, '_data', {})).filter(
                key =>
                    typeof this.target[key] !== 'function' &&
                    this.$get(this.target, 'preserveStateConfig.preserveKey', () => true)(key) &&
                    key !== 'preserveStateConfig'
            )
        },

        getTargetPayload() {
            const payload = {}

            this.getTargetProperties().forEach(key => (payload[key] = this.target[key]))

            return payload
        },

        getComponentKey(component) {
            return this.$get(
                component,
                '$vnode.key',
                this.$get(component, '$options._componentTag')
            )
        },

        restore() {
            const payload = SessionStore.get(this._stateKey)

            if (payload) {
                Object.keys(payload).forEach(key => this.$set(this.target, key, payload[key]))
            }
        },
    },

    computed: {
        target() {
            return this
        },
    },
}
